goog.provide('el8.app.shared.clickItemOpts');

goog.require('el8.template.clickItem');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.ptdata.careTeamProviders');
//goog.require('el8.app.shared.network.viewEditConnection');


el8.app.shared.clickItemOpts = {

    physicians: function(opts) {
        opts = opts || {};
        return {
            maxLength: 100,
            height: 16,
            mindreaderOpts: el8.appshared.mindreaderOpts.physicians(opts),
            formatSelectedItem: function(mrItem) {
                var id = mrItem['id'];
                var contact = el8.data.physicians.getById(id);
                var soyMap = contact.asSoyMap();
                if (el8Globals.FEATURES.PLR4Everyone) {
                    soyMap = el8.ptdata.careTeamProviders.applyPlrStatusToSoyMap(soyMap);
                }
                return el8.template.clickItem.selectedPhysician({physician: soyMap});
            },
            formatManualItem: function(mrItem) {
                return el8.template.clickItem.manualPhysician({text: mrItem.freeText});
            }
        };
    },

    detailedPhysicians: function(opts) {
        opts = opts || {};
        return {
            maxLength: 100,
            height: 16,
            mindreaderOpts: el8.appshared.mindreaderOpts.physicians(opts),
            formatSelectedItem: function(mrItem) {
                var id = mrItem['id'];
                var contact = el8.data.physicians.getById(id);
                var soyMap = contact.asSoyMap();
                soyMap['providerLogo'] = mrItem['provider_logo']; // add the logo flag from Solr to the physician map
                if (el8Globals.FEATURES.PLR4Everyone) {
                    soyMap = el8.ptdata.careTeamProviders.applyPlrStatusToSoyMap(soyMap);
                }
                return el8.template.clickItem.selectedDetailedPhysician({physician: soyMap});
            },
            formatManualItem: function(mrItem) {
                return el8.template.clickItem.manualDetailedPhysician({text: mrItem.freeText});
            },
            clickDisplayEltFn: function(e) {
                var $target = $(e.target);
                if ($target.hasClass('edit-trigger')) {
                    var id = $target.data('id');
                    if (id) {
                        el8.app.shared.network.viewEditConnection.show({
                            contactId: id,
                            callbackFn: opts.newContactCb || null
                        });
                    } else {
                        var text = $target.data('text') || '';
                        el8.app.shared.network.viewEditConnection.show({
                            contactName: text,
                            callbackFn: opts.newContactCb || null
                        });
                    }
                    return false;
                }
            }
        };
    }

};

